export default __webpack_public_path__ + "static/MandeepSodhi-e5e13a7146ee4f102c880ea4029317ae.jpg";